(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filters-usps"]) return;
  try {
    
  // const openFilters = document.querySelector('.open-filters');
  // openFilters.addEventListener('click',()=>{
  //   document.querySelector('#main-collection-filters .mobile-facets__open-wrapper').click();
  // })

  const swipers = document.querySelectorAll('.usp-swiper');
  const breakpoint = window.matchMedia('(min-width:990px)');
  let uspSwiper;

  const breakpointChecker = function (swiper) {
    const uspSwiperItem = swiper.querySelectorAll('.swiper-slide');
    const sectionId = swiper.getAttribute('data-attr');
    if (breakpoint.matches === true && uspSwiperItem.length <= 4) {
      // clean up old instances and inline styles when available
      if (swiper.swiper && typeof swiper.swiper.destroy === 'function') {
        console.log(swiper.swiper);
        console.log(swiper.swiper.params);
        swiper.swiper.destroy(true, true);
      }
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if (breakpoint.matches === false) {
      // fire small viewport version of swiper
      return enableSwiper(sectionId);
    }
  };

  const enableSwiper = function (sectionId) {
    uspSwiper = new Swiper(`[data-attr=${sectionId}]`, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: `[data-attr=${sectionId}] .swiper-pagination`,
      },
      navigation: {
        nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
        prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
      },
    });
  };
  for (let i = 0; i < swipers.length; i++) {
    window.addEventListener('resize', function () {
      breakpointChecker(swipers[i]);
    });
    breakpointChecker(swipers[i]);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    

  const swipers = document.querySelectorAll('.collection-list-swiper');
  const breakpoint = window.matchMedia( '(min-width:990px)' )
  let collectionListSwiper;
  
  const breakpointChecker = function(swiper) {    
    const collectionListSwiperItem = swiper.querySelectorAll(".swiper-slide");
    const sectionId = swiper.getAttribute('data-attr');
    if (collectionListSwiperItem.length >= 3) {      
      swiper.closest('.collection-list-wrapper').style.paddingRight = '0'
    } 
 
    if ( breakpoint.matches === true && collectionListSwiperItem.length == 1 ) {  
      swiper.closest('.collection-list-wrapper').querySelector('.swiper-controls').style.display = 'none'
      // clean up old instances and inline styles when available      
      if(swiper.swiper && typeof swiper.swiper.destroy === 'function'){ 
        swiper.swiper.destroy(true, true);
      }
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if ( breakpoint.matches === true && collectionListSwiperItem.length == 2 ) {
      swiper.closest('.collection-list-wrapper').querySelector('.swiper-controls').style.display = 'none'   
      if(swiper.swiper && typeof swiper.swiper.destroy === 'function'){ 
        swiper.swiper.destroy(true, true);
      }
      return;
    } else if ( breakpoint.matches === false && collectionListSwiperItem.length == 2 ) {
      // fire small viewport version of swiper  
      swiper.closest('.collection-list-wrapper').querySelector('.swiper-controls').style.display = 'flex'   
      return enableSwiper(collectionListSwiperItem.length, sectionId);
    } else if (breakpoint.matches === true && collectionListSwiperItem.length >= 2 ) {  
       return enableSwiper(collectionListSwiperItem.length, sectionId);
    } else if (breakpoint.matches === false && collectionListSwiperItem.length >= 2 ) {  
       return enableSwiper(collectionListSwiperItem.length, sectionId);
    } else if (breakpoint.matches === false && collectionListSwiperItem.length == 1 ) {  
      swiper.closest('.collection-list-wrapper').querySelector('.swiper-controls').style.display = 'none'
      // clean up old instances and inline styles when available      
      if(swiper.swiper && typeof swiper.swiper.destroy === 'function'){ 
        swiper.swiper.destroy(true, true);
      }
      // or/and do nothing
      return;
    }
  };   

  const enableSwiper = function(collectionListSwiperItemLength, sectionId) {   
    if (collectionListSwiperItemLength >= 3) {    
      //if (collectionListSwiper == undefined) {
        collectionListSwiper = new Swiper(`[data-attr=${sectionId}]`, {
          slidesPerView: 2.5,
          spaceBetween: 24,
          mousewheel: {
            forceToAxis: true
          },
          pagination: {
            el: `[data-attr=${sectionId}] .swiper-pagination`,
          },
          navigation: {
            nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
            prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
          },
          breakpoints: {
            320: {
              slidesPerView: 1.1,
              spaceBetween: 16,
            },			
            750: {
              slidesPerView: 1.5,
              spaceBetween: 24,
            },
            990: {
              slidesPerView: 2.44,
              spaceBetween: 24,
            }
          }
        });     
      //}      
    } else if (( collectionListSwiperItemLength == 2)  && window.innerWidth <= 990) {          
      //if (collectionListSwiper == undefined) {
        collectionListSwiper = new Swiper(`[data-attr=${sectionId}]`, {
          slidesPerView: 1.3,
          spaceBetween: 16,
          pagination: {
            el: `[data-attr=${sectionId}] .swiper-pagination`,
          },
          navigation: {
            nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
            prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
          },
        });      
      //}
    }
  }
  for(let i = 0; i < swipers.length; i++) {   
    window.addEventListener('resize', function() {
      breakpointChecker(swipers[i]);
    });
    breakpointChecker(swipers[i]);
 }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curated-products"] && !Shopify.designMode) return;
  try {
    

const swipers = document.querySelectorAll('.curated-products-swiper');
const breakpoint = window.matchMedia( '(min-width:990px)' )
let curatedProductsSwiper;

const breakpointChecker = function(swiper) {  
  const curatedProductsSwiperItem = swiper.querySelectorAll(".swiper-slide");
  const sectionId = swiper.getAttribute('data-attr');
  if (curatedProductsSwiperItem.length >= 3) {
    swiper.closest('.curated-products').style.paddingRight = '0'
  }
  else{
    swiper.closest('.curated-products').querySelector('.swiper-button-prev').classList.add('hide-desktop');
    swiper.closest('.curated-products').querySelector('.swiper-button-next').classList.add('hide-desktop');
  }

  if ( breakpoint.matches === true && curatedProductsSwiperItem.length <= 1 ) {    
    // clean up old instances and inline styles when available      
    if(swiper.swiper && typeof swiper.swiper.destroy === 'function'){ 
      swiper.swiper.destroy(true, true);
    }
    // or/and do nothing
    return;
    // else if a small viewport and single column layout needed
  } else if ( breakpoint.matches === true && curatedProductsSwiperItem.length == 2 ) {
    swiper.closest('.curated-products').querySelector('.swiper-controls').style.display = 'none'   
    if(swiper.swiper && typeof swiper.swiper.destroy === 'function'){ 
      swiper.swiper.destroy(true, true);
    }
    return;
  } else if ( breakpoint.matches === false && curatedProductsSwiperItem.length == 2 ) {
    // fire small viewport version of swiper  
    swiper.closest('.curated-products').querySelector('.swiper-controls').style.display = 'flex'   
    return enableSwiper(curatedProductsSwiperItem.length, sectionId);
  } else if (breakpoint.matches === true && curatedProductsSwiperItem.length >= 2 ) {  
      return enableSwiper(curatedProductsSwiperItem.length, sectionId);
  } else if (breakpoint.matches === false && curatedProductsSwiperItem.length >= 2 ) {  
      return enableSwiper(curatedProductsSwiperItem.length, sectionId);
  }
};   

const enableSwiper = function(curatedProductsSwiperItemLength, sectionId) {   
  if (curatedProductsSwiperItemLength >= 3) {    
    curatedProductsSwiper = new Swiper(`[data-attr=${sectionId}]`, {
      slidesPerView: 3,
      spaceBetween: 24,
      autoHeight:true,
      pagination: {
        el: `[data-attr=${sectionId}] .swiper-pagination`,
      },
      navigation: {
        nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
        prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 16,
        },			
        750: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
      }
    });            
  } else if (( curatedProductsSwiperItemLength == 2)  && window.innerWidth <= 990) {          
    curatedProductsSwiper = new Swiper(`[data-attr=${sectionId}]`, {
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight:true,
      pagination: {
        el: `[data-attr=${sectionId}] .swiper-pagination`,
      },
      navigation: {
        nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
        prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
      },
    });          
  }
}
for(let i = 0; i < swipers.length; i++) {   
  window.addEventListener('resize', function() {
    breakpointChecker(swipers[i]);
  });
  breakpointChecker(swipers[i]);
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curated-reviews"] && !Shopify.designMode) return;
  try {
    
  // get time passed from review date
  const dates = document.querySelectorAll('.curated-reviews .swiper .swiper-slide .review-date input[type="hidden"]') 
  dates.forEach(date => {
    const dateId = date.getAttribute('data-attr')
    const dateValue = date.value

    function getTimePassed(date) {
      var now =  new Date().toLocaleDateString("en-US"); 
      var reviewDate = new Date(date).toLocaleDateString("en-US");
      var timePassedMs = Date.parse(now) - Date.parse(reviewDate);
      var timePassed = Math.round( timePassedMs / (1000 * 60 * 60 * 24));  
      
      if (timePassed < 1) {
        return "today"
      } else if (timePassed == 1) {
        return timePassed + " day ago"
      } else {
        return timePassed + " days ago"
      }  
    }

    const reviewDatePlaceholder = date.closest('.review').querySelector('.review-date .date')
    if(getTimePassed(date.value).includes('NaN')){
      reviewDatePlaceholder.innerHTML = "";
    }
    else{
      reviewDatePlaceholder.innerHTML = getTimePassed(date.value);
    }
  })


  const swipers = document.querySelectorAll('.curated-reviews-swiper');
  const breakpoint = window.matchMedia( '(min-width:990px)' )
  let curatedReviewsSwiper;

  const breakpointChecker = function(swiper) {  
    const curatedReviewsSwiperItem = swiper.querySelectorAll(".swiper-slide");
    const sectionId = swiper.getAttribute('data-attr');
    const navId = swiper.closest('.page-width').getAttribute('data-attr2');    
  
    if (breakpoint.matches === true && curatedReviewsSwiperItem.length <= 1 ) {    
      swiper.parentElement.querySelector('.controls-wrap').style.display = 'none'
      // clean up old instances and inline styles when available      
      if(swiper.swiper && typeof swiper.swiper.destroy === 'function'){ 
        swiper.swiper.destroy(true, true);
      }
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if ( breakpoint.matches === true && curatedReviewsSwiperItem.length >= 2 ) {   
        return enableSwiper(curatedReviewsSwiperItem.length, sectionId, navId);
    } else if ( breakpoint.matches === false && curatedReviewsSwiperItem.length >= 2 ) {
      // fire small viewport version of swiper       
      return enableSwiper(curatedReviewsSwiperItem.length, sectionId, navId);
    }   
  };   

  const enableSwiper = function(curatedReviewsSwiperItemLength, sectionId, navId) {       
    if (curatedReviewsSwiper == undefined) {
      curatedReviewsSwiper = new Swiper(`[data-attr=${sectionId}]`, {
        slidesPerView: 1,
        spaceBetween: 10,
        effect: "fade",
        autoHeight: true,
        pagination: {
          el: `[data-attr=${sectionId}] .swiper-pagination`,
        },
        navigation: {
          nextEl: `[data-attr2=${navId}] .swiper-button-next`,
          prevEl: `[data-attr2=${navId}] .swiper-button-prev`,
        },
        breakpoints: {             
          320: {
            pagination: {
              el: `[data-attr2=${navId}] .swiper-pagination-mobile`,
            },                     
          },              
          990: {
            pagination: {
              el: `[data-attr=${sectionId}] .swiper-pagination`,
            },                     
          }               
        }     
      });     
    }
  }
  for(let i = 0; i < swipers.length; i++) {   
    window.addEventListener('resize', function() {
      breakpointChecker(swipers[i]);
    });
    breakpointChecker(swipers[i]);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-blog-posts"] && !Shopify.designMode) return;
  try {
    
const articleSwipers = document.querySelectorAll('.articles-swiper');

const enableArticleSwiper = (sectionId) =>{
  var swiperInit = new Swiper(`[data-attr=${sectionId}]`, {
    slidesPerView: 1,
    spaceBetween: 12,
    navigation: {
      nextEl: `.swiper-arrows-${sectionId} .swiper-button-next`,
      prevEl: `.swiper-arrows-${sectionId} .swiper-button-prev`,
    },
    pagination: {
      el: `.swiper-arrows-${sectionId} .swiper-pagination`,
      clickable: true,
    },
    breakpoints:{
      750:{
        slidesPerView: 2,
        spaceBetween: 12
      },
      990:{
        slidesPerView: 3,
        spaceBetween: 24
      }
    }
  });
}

if(articleSwipers.length){
  for(let i = 0; i < articleSwipers.length; i++){
    const sectionId = articleSwipers[i].getAttribute('data-attr');
    enableArticleSwiper(sectionId);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-newsletter"] && !Shopify.designMode) return;
  try {
    
  const currTheme = localStorage.getItem('defaultStyle');

  const targetNode = document.querySelector('.klaviyo-form-RPce7C');

  const config = { childList: true, subtree: true };

  const callback = (mutationList, observer) => {
    let optionChecked = false
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        if(document.querySelector('[aria-label="Bedroom"]') && document.querySelector('[aria-label="Nursery"]')) {
          const bedroomNews = document.querySelectorAll('[aria-label="Bedroom"]');
          const nurseryNews = document.querySelectorAll('[aria-label="Nursery"]');

          if(optionChecked === false) {
            if(currTheme == 'bedroom'){
              bedroomNews.forEach(input => {
                input.click();
              })
            }
            if(currTheme == 'nursery'){
              nurseryNews.forEach(input => {
                input.click();
              })
            }
            observer.disconnect();
            optionChecked = true;
          }
        }
      }
    }
  };

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);

  const targetNodeMobile = document.querySelector('.klaviyo-form-VmFZqb');

  observer.observe(targetNodeMobile, config);


    // const verifyChecked = (e) => {
    //   if(bedroomNews.checked && nurseryNews.checked){
    //     tagsInput.value = "bedroom-newsletter,nursery-newsletter";
    //     newsFormErrors.classList.add("hidden");
    //   }
    //   else if(bedroomNews.checked){
    //     tagsInput.value = "bedroom-newsletter";
    //     newsFormErrors.classList.add("hidden");
    //   }
    //   else if(nurseryNews.checked){
    //     tagsInput.value = "nursery-newsletter";
    //     newsFormErrors.classList.add("hidden");
    //   }
    // }

    // nurseryNews.addEventListener('change', verifyChecked)

    // bedroomNews.addEventListener('change', verifyChecked)

    // const newsForm = document.querySelector('.newsletter-form');
    // const newsFormErrors = document.getElementById('Newsletter-checkbox-error');

    // const submitNews = newsForm.querySelector('button[type="submit"]');
    // submitNews.addEventListener('click',(e) => {
    //   const checked = false;
    //   if(document.getElementById('bedroom-news').checked || document.getElementById('nursery-news').checked){
    //     checked = true;
    //   }
    //   if(!checked){
    //     e.preventDefault();
    //     newsFormErrors.classList.remove("hidden");
    //   }
    // })

    // newsForm.addEventListener('submit',(e) => {
    //   const checked = false;
    //   if(document.getElementById('bedroom-news').checked || document.getElementById('nursery-news').checked){
    //     checked = true;
    //   }
    //   if(!checked){
    //     e.preventDefault();
    //     newsFormErrors.classList.remove("hidden");
    //   }
    // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  const isSafari = window.safari !== undefined;
  if (isSafari) document.querySelector(".footer__blocks").classList.add("safari-fix");

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  window.addEventListener('DOMContentLoaded', ()=>{
    console.trace('footerAccordion')
    const footerAccordions = document.querySelectorAll(".footer-block__heading");
    footerAccordions.forEach((item) => {
      item.addEventListener("click", (e) => {
        const parentItem = e.currentTarget.parentElement;
        const currentActive = document.querySelector(".footer-block--menu.active");
        if(currentActive && parentItem != currentActive){
          currentActive.classList.remove("active");
        }
        parentItem.classList.contains("active") ? parentItem.classList.remove("active") : parentItem.classList.add("active");
      });
    });
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-bedroom"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header-bedroom');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      document.querySelector('.mega-menu__slideout').style.display = 'block';
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let headerOffset = 0;
      if (window.innerWidth > 990) {
        headerOffset = 90 + 55;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      // if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (scrollTop < this.currentScrollTop && scrollTop > headerOffset) {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      if (scrollTop >= headerOffset) {
        // if (scrollTop >= document.documentElement.clientHeight - headerOffset) {
        requestAnimationFrame(this.reveal.bind(this));
      }
    }

    hide() {
      // this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      // this.header.classList.add('shopify-section-header-sticky', 'animate');
      // this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      // this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nursery"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header-nursery');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      document.querySelector('.mega-menu__slideout').style.display = 'block';
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let headerOffset = 0;
      if (window.innerWidth > 990) {
        headerOffset = 90 + 55;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop < this.currentScrollTop && scrollTop > headerOffset) {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      if (scrollTop >= document.documentElement.clientHeight - headerOffset) {
        requestAnimationFrame(this.reveal.bind(this));
      }
    }

    hide() {
      // this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      // this.header.classList.add('shopify-section-header-sticky', 'animate');
      // this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      // this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
const tabSwipers = document.querySelectorAll(".image-with-text .tab-swiper");

const changeNavTop = (tabSwiper) =>{
  let parentElement = tabSwiper.closest('.image-with-text');
  const tabs = parentElement.querySelector('.tab-swiper-nav');
  const thisSwiper = parentElement.querySelector('.tab-swiper-nav + .swiper');
  const slides = thisSwiper.querySelectorAll('.swiper-slide');
  const activeTab = parseInt(tabs.getAttribute('data-active'));
  if(window.innerWidth < 750){
    const slide = slides[activeTab];
    let slideImage = slide.querySelector('.image-with-text__media-item')
    let height = slideImage.offsetHeight;
    let margin = slideImage.currentStyle || window.getComputedStyle(slideImage)
    height = height + (parseInt(margin.marginBottom.split('px')[0])/2);
    tabs.style.top = `${height}px`;
  }
  else{
    if(tabs.hasAttribute("style")){
      tabs.removeAttribute("style");
    }
  }
}

const setActiveTab = (tabSwiper,swiper)=>{
  let parentElement = tabSwiper.closest('.image-with-text');
  let tabs = parentElement.querySelectorAll('.tab-swiper-nav p');
  let activeTab = parseInt(tabs[0].closest('.tab-swiper-nav').getAttribute('data-active'));


  const scrollToTab = (target, outer) => {
    var out = $(outer);
    var tar = $(target);
    var x = out.width();
    var y = tar.outerWidth(true);
    var z = tar.index();
    var q = 0;
    var m = out.find('p');
    for(var i = 0; i < z; i++){
      q+= $(m[i]).outerWidth(true);
    }
    out.scrollLeft(Math.max(0, q - (x - y)/2));
  }

  Array.from(tabs).forEach((el, index)=>{
    el.addEventListener('click',function(){
      swiper.slideTo(index);
      Array.from(tabs).forEach((el) => el.classList.remove('active'));
      el.classList.add('active');
      activeTab = index;
      const parent = tabs[0].closest('.tab-swiper-nav');
      // scrollToTab(el,parent);
      scrollToTab(el, parent);
      tabs[0].closest('.tab-swiper-nav').setAttribute('data-active', index);
    })
    el.addEventListener('click',()=>{
      changeNavTop(tabSwiper)
    });
  })
  window.addEventListener('resize', ()=>{
    changeNavTop(tabSwiper)
  });
  changeNavTop(tabSwiper);
  document.addEventListener('DOMContentLoaded', function () {
    const ele = tabs[0].closest('.tab-swiper-nav');
    ele.style.cursor = 'grab';

    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function (e) {
        ele.style.cursor = 'grabbing';
        ele.style.userSelect = 'none';

        pos = {
            left: ele.scrollLeft,
            top: ele.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY,
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        // Scroll the element
        ele.scrollTop = pos.top - dy;
        ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function () {
        ele.style.cursor = 'grab';
        ele.style.removeProperty('user-select');

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
    };

    // Attach the handler
    ele.addEventListener('mousedown', mouseDownHandler);
  });
}
const enableSwiper = (tabSwiper)=>{
  const sectionId = tabSwiper.getAttribute('data-attr');
  const tabNavTitles = tabSwiper.parentElement.querySelectorAll('.tab-swiper-nav p');
  let activeSlide = parseInt(tabSwiper.parentElement.querySelector('.tab-swiper-nav').getAttribute('data-activeSlide')) - 1;
  if(activeSlide < 0 || activeSlide > tabNavTitles.length){
    tabSwiper.parentElement.querySelector('.tab-swiper-nav').setAttribute('data-activeSlide', "1");
    activeSlide = 0;
  }
  var swiperInit = new Swiper(`[data-attr=${sectionId}]`, {
    slidesPerView: 1,
    spaceBetween: 0,
    initialSlide: activeSlide,
    effect: 'fade',
    autoHeight: true,
    fadeEffect: {
      crossFade: true
    },
    allowTouchMove: false
  });
  tabNavTitles.forEach((el, index) =>{
    if(index != activeSlide){
      el.classList.remove('active');
    }
    else{
      el.classList.add('active');
    }
  })
  window.addEventListener('resize',()=>{
    setActiveTab(tabSwiper,swiperInit);
  })
  setActiveTab(tabSwiper,swiperInit);
}

for(let i = 0; i < tabSwipers.length; i++){
  enableSwiper(tabSwipers[i]);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-collage"] && !Shopify.designMode) return;
  try {
    
  const logoSwipers = document.querySelectorAll('.logos-swiper');

  const enableLogoSwiper = (sectionId)=>{
    var swiperInit = new Swiper(`[data-attr=${sectionId}]`, {
      slidesPerView: 2,
      spaceBetween: 36,
      grid:{
        rows: 2,
        fill: 'row',
      },
      navigation: {
        nextEl: `.swiper-arrows-${sectionId} .swiper-button-next`,
        prevEl: `.swiper-arrows-${sectionId} .swiper-button-prev`,
      },
      pagination: {
        el: `.swiper-arrows-${sectionId} .swiper-pagination`,
        clickable: true
      },
      breakpoints:{
        750: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 0,
          grid:{
            rows:1
          },
        },
        990: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 0,
          grid:{
            rows:1
          },
        },
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 0,
          grid:{
            rows:1
          },
        }
      }
    });
  }

  if(logoSwipers.length){
    for(let i = 0; i < logoSwipers.length; i++){
      const sectionId = logoSwipers[i].getAttribute('data-attr');
      enableLogoSwiper(sectionId);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  //note modal
  const body = document.querySelector('body');
  const noteWrapper = document.querySelectorAll('.cart-note-wrapper');

  const tooltip = document.querySelector('.tooltip');

  tooltip.addEventListener('mouseenter', () => {
    tooltip.classList.add('tooltip--active');
  });

  tooltip.addEventListener('focus', () => {
    tooltip.classList.add('tooltip--active');
  });
  tooltip.addEventListener('blur', (e) => {
    tooltip.classList.remove('tooltip--active');
    tooltip.querySelector('.tooltip__text a').focus();
  });
  tooltip.querySelector('.tooltip__text a').addEventListener('blur', () => {
    tooltip.classList.remove('tooltip--active');
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.tooltip')) {
      tooltip.classList.remove('tooltip--active');
    }
  });

  noteWrapper.forEach((note) => {
    const modalToggle = note.querySelector('.cart-note-toggle');
    const modalToggleText = note.querySelector('.cart-note-toggle p');
    const modal = note.querySelector('.cart__note');
    const close = note.querySelector('.cart__note .close');
    const textArea = note.querySelector('.cart__note textarea');
    const movedTextArea = note.querySelector('.order-note .order-note-body');
    const movedTitle = note.querySelector('.order-note .order-note-title');
    const addMessage = note.querySelector('.cart__note .btn');

    const closeOutsideClick = (e) => {
      if (
        modal.classList.contains('is-active') &&
        !e.target.closest('.cart__note') &&
        !e.target.closest('.cart-note-toggle')
      ) {
        modal.classList.remove('is-active');
        body.classList.remove('modal-open');
      }
    };

    // when pressing enter, click modalToggle
    modalToggle.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        modalToggle.click();
        textArea.focus();
        event.preventDefault();
        document.addEventListener('click', closeOutsideClick);
      }
    });
    modalToggle.addEventListener('click', () => {
      modal.classList.toggle('is-active');
      body.classList.toggle('modal-open');
      document.addEventListener('click', closeOutsideClick);
    });
    // when pressing enter, click close
    close.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        modal.classList.toggle('is-active');
        body.classList.toggle('modal-open');
        console.log(modalToggle);
        modalToggleText.focus();
        event.preventDefault();
        document.removeEventListener('click', closeOutsideClick);
      }
    });
    close.addEventListener('click', () => {
      modal.classList.toggle('is-active');
      body.classList.toggle('modal-open');
      document.removeEventListener('click', closeOutsideClick);
    });

    // when pressing enter, click addMessage
    addMessage.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        addMessage.click();
        modalToggleText.focus();
        event.preventDefault();
      }
    });
    addMessage.addEventListener('click', () => {
      modal.classList.toggle('is-active');
      body.classList.toggle('modal-open');
      if (textArea.value !== '') {
        modalToggleText.innerHTML = 'Edit Order Note';
        movedTextArea.innerHTML = `"${textArea.value}"`;
        movedTitle.style.display = 'block';
      } else {
        modalToggleText.innerHTML = 'Add Order Note';
        movedTextArea.innerHTML = '';
        movedTitle.style.display = 'none';
      }
    });
    //on page load
    if (textArea.value !== '') {
      modalToggleText.innerHTML = 'Edit Order Note';
      movedTextArea.innerHTML = `"${textArea.value}"`;
      movedTitle.style.display = 'block';
    } else {
      modalToggleText.innerHTML = 'Add Order Note';
      movedTextArea.innerHTML = '';
      movedTitle.style.display = 'none';
    }
  });

  // sticky cart footer
  // on load and resize
  const footer = () => {
    const stickyCartFooter = document.querySelector('.cart__footer.fixed-footer');
    const footerHeight = stickyCartFooter.offsetHeight;
    stickyCartFooter.style.marginTop = `-${footerHeight}px`;
  };
  footer();
  window.addEventListener('resize', footer);

  const cartFooter = document.querySelector('.cart__footer');

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  const sticky = cartFooter.parentElement.querySelector('.cart__footer.fixed-footer');
  const checkSticky = () => {
    if (window.innerWidth <= 750) {
      if (document.body.style.overflow == 'hidden' && document.body.style.position == 'fixed') {
        cartFooter.style.zIndex = '3';
      } else {
        cartFooter.style.zIndex = '';
      }
      if (!isInViewport(cartFooter) && window.scrollY <= cartFooter.offsetTop) {
        if (!(document.body.style.overflow == 'hidden' && document.body.style.position == 'fixed')) {
          sticky.classList.add('sticky');
          sticky.style.display = 'block';
        }
      } else {
        sticky.classList.remove('sticky');
        sticky.style.display = 'none';
      }
    }
  };
  document.addEventListener('scroll', checkSticky);
  checkSticky();
  document.addEventListener('DOMContentLoaded', checkSticky);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-manual"] && !Shopify.designMode) return;
  try {
    
  let swipers = document.querySelectorAll('.extended-card-swiper');
  const breakpoint = window.matchMedia('(min-width:751px)');

  const enableSwiper = function (sectionId) {
    let extendedCardSwiper = new Swiper(`[data-attr=${sectionId}]`, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
        prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
      },
    });
  };

  const enableAllSwipers = () => {
    for (let i = 0; i < swipers.length; i++) {
      let ratio = (1 / 1.5) * 100;
      if (swipers[i].style != `--ratio-percent: ${ratio}%`) {
        swipers[i].style = `--ratio-percent: ${ratio}%`;
      }
      if (swipers[i].closest('.card').style != `--ratio-percent: ${ratio}%`) {
        swipers[i].closest('.card').style = `--ratio-percent: ${ratio}%`;
      }
      let sectionId = swipers[i].getAttribute('data-attr');
      if (swipers[i].swiper == undefined) {
        enableSwiper(sectionId);
      }
    }
  };

  const disableAllSwipers = () => {
    for (let i = 0; i < swipers.length; i++) {
      if (swipers[i].swiper != undefined) {
        let ratio = (1 / 2.29) * 100;
        if (swipers[i].style != `--ratio-percent: ${ratio}%`) {
          swipers[i].style = `--ratio-percent: ${ratio}%`;
        }
        if (swipers[i].closest('.card').style != `--ratio-percent: ${ratio}%`) {
          swipers[i].closest('.card').style = `--ratio-percent: ${ratio}%`;
        }
        swipers[i].swiper.destroy(true, true);
      }
    }
  };

  function resizeHandler() {
    if (breakpoint.matches === false) {
      enableAllSwipers();
    } else {
      disableAllSwipers();
    }
  }

  document.addEventListener('swym:collections-loaded', function () {
    swipers = document.querySelectorAll('.extended-card-swiper');
    resizeHandler();
  });
  window.addEventListener('resize', resizeHandler);

  document.addEventListener('DOMContentLoaded', function () {
    if (breakpoint.matches === false) {
      enableAllSwipers();
    }
    //back to top button on collection page
    document.querySelector('#collection_back_to_top').addEventListener('click', function () {
      //scroll to top of page
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  });

  if (breakpoint.matches === false) {
    enableAllSwipers();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-variants"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    //back to top button on collection page
    document.querySelector('#collection_back_to_top').addEventListener('click', function () {
      //scroll to top of page
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  let swipers = document.querySelectorAll('.extended-card-swiper');
  const breakpoint = window.matchMedia('(min-width:751px)');

  const enableSwiper = function (sectionId) {
    let extendedCardSwiper = new Swiper(`[data-attr=${sectionId}]`, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
        prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
      },
    });
  };

  const enableAllSwipers = () => {
    for (let i = 0; i < swipers.length; i++) {
      let ratio = (1 / 1.5) * 100;
      if (swipers[i].style != `--ratio-percent: ${ratio}%`) {
        swipers[i].style = `--ratio-percent: ${ratio}%`;
      }
      if (swipers[i].closest('.card').style != `--ratio-percent: ${ratio}%`) {
        swipers[i].closest('.card').style = `--ratio-percent: ${ratio}%`;
      }
      let sectionId = swipers[i].getAttribute('data-attr');
      if (swipers[i].swiper == undefined) {
        enableSwiper(sectionId);
      }
    }
  };

  const disableAllSwipers = () => {
    for (let i = 0; i < swipers.length; i++) {
      if (swipers[i].swiper != undefined) {
        let ratio = (1 / 2.29) * 100;
        if (swipers[i].style != `--ratio-percent: ${ratio}%`) {
          swipers[i].style = `--ratio-percent: ${ratio}%`;
        }
        if (swipers[i].closest('.card').style != `--ratio-percent: ${ratio}%`) {
          swipers[i].closest('.card').style = `--ratio-percent: ${ratio}%`;
        }
        swipers[i].swiper.destroy(true, true);
      }
    }
  };

  function resizeHandler() {
    if (breakpoint.matches === false) {
      enableAllSwipers();
    } else {
      disableAllSwipers();
    }
  }

  document.addEventListener('swym:collections-loaded', function () {
    swipers = document.querySelectorAll('.extended-card-swiper');
    resizeHandler();
  });
  window.addEventListener('resize', resizeHandler);

  document.addEventListener('DOMContentLoaded', function () {
    if (breakpoint.matches === false) {
      enableAllSwipers();
    }
    //back to top button on collection page
    document.querySelector('#collection_back_to_top').addEventListener('click', function () {
      //scroll to top of page
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  });

  if (breakpoint.matches === false) {
    enableAllSwipers();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-wishlist"]) return;
  try {
    

let lists = [];


document.addEventListener('DOMContentLoaded', function() {
  const wishlistContainer = document.querySelector('#swym-wishlist-render-container');
  const observeDOM = (function(){
    let MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  
    return function( obj, callback ){
      if( !obj || obj.nodeType !== 1 ) return; 
  
      if( MutationObserver ){
        // define a new observer
        var mutationObserver = new MutationObserver(callback)
  
        // have the observer observe foo for changes in children
        mutationObserver.observe( obj, { childList:true, subtree:true })
        return mutationObserver
      }
      
      // browser support fallback
      else if( window.addEventListener ){
        obj.addEventListener('DOMNodeInserted', callback, false)
        obj.addEventListener('DOMNodeRemoved', callback, false)
      }
    }
  })();

  let lists;
  let selectWish;

  const createSelect = () => {
    if(!document.getElementById('swym-wishlist-select')) {
      const elementToAppend = document.createElement('div');
      elementToAppend.classList.add('select');
      const select = document.createElement('select');
      elementToAppend.appendChild(select);
      select.id = 'swym-wishlist-select';
      select.className = 'swym-wishlist-select select__select';
      lists.forEach((list, index) => {
        const option = document.createElement('option');
        const optionName = list.querySelector('.swym-wishlist-name').innerText;
        const prodNumber = list.querySelector('.swym-wishlist-product-count').innerText.split(' ')[0];
        option.value = index;
        option.innerHTML = "List: " + optionName;
        select.appendChild(option);
      });
      const insertReference = document.querySelector('.swym-wishlist-list');
      insertReference.parentNode.insertBefore(elementToAppend, insertReference);
      selectWish = select;
      lists[0].click();
    }
  }

  observeDOM(wishlistContainer, function(m){
    m.forEach(function(mutation){
      if(mutation.addedNodes){
        for(let i = 0; i < mutation.addedNodes.length; i++){
          if(mutation.addedNodes[i].classList.contains('swym-wishlist-detail-content') && mutation.addedNodes[i].querySelector('.swym-back-btn')){
            selectWish.addEventListener('change', () => {
              const backBtn = document.querySelector('.swym-back-btn');
              backBtn.click();
            })
          }
          if(mutation.addedNodes[i].classList.contains('swym-wishlist-list')){
            if(mutation.addedNodes[i].querySelectorAll('.swym-wishlist-list-card')[selectWish.value]){
              mutation.addedNodes[i].querySelectorAll('.swym-wishlist-list-card')[selectWish.value].click();
            }
          }
        }
      }
    });
    if(m[0]?.addedNodes[0]?.querySelectorAll('.swym-wishlist-list-card').length > 0){
      const modalContainer = document.querySelector('#swym-plugin');
      observeDOM(modalContainer, function(m){
        m.forEach(function(mutation){
          const duplicateWish = mutation.addedNodes[0].querySelector('.swym-duplicate-wishlist-btn');
          if(duplicateWish){
            duplicateWish.addEventListener('click',() => {
              window.location.reload();
            })
          }
          const deleteWish = mutation.addedNodes[0].querySelector('.swym-clear-wishlist-btn');
          if(deleteWish){
            deleteWish.addEventListener('click',() => {
              window.location.reload();
            })
          }
        });
      })
      lists = m[0].addedNodes[0].querySelectorAll('.swym-wishlist-list-card');
      if(lists.length > 0){
        createSelect();
      }
    }
  })

  const duplicateWish = document.querySelector('.swym-duplicate');
  if(duplicateWish){
    duplicateWish.addEventListener('click', () => {
      window.location.reload();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bases"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  // Product accordion
  const accordionList = document.querySelectorAll('.accordion-item');

  accordionList.forEach((event) =>
    event.addEventListener('click', () => {
      if (event.classList.contains('accordion-product-option')) {
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
        }
        event.classList.add('active');
      } else {
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (!event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
          event.classList.add('active');
        }
      }
    })
  );
  //product variants select
  const productVariantsSelect = document.querySelectorAll('.variant-select .select__select');

  // Product slider
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 24,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    threshold: 50,
  });
  var swiper2 = new Swiper('.swiper-large', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const sliderThumb = document.querySelector('.swiper-thumbs');
  window.addEventListener('resize', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
  });
  window.addEventListener('load', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      //sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      //sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-beds"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  // Product accordion
  const accordionList = document.querySelectorAll('.accordion-item');

  accordionList.forEach((event) =>
    event.addEventListener('click', () => {
      if (event.classList.contains('accordion-product-option')) {
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
        }
        event.classList.add('active');
      } else {
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (!event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
          event.classList.add('active');
        }
      }
    })
  );
  //product variants select
  const productVariantsSelect = document.querySelectorAll('.variant-select .select__select');

  // Product slider
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 24,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    threshold: 50,
  });
  var swiper2 = new Swiper('.swiper-large', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const sliderThumb = document.querySelector('.swiper-thumbs');
  window.addEventListener('resize', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
  });
  window.addEventListener('load', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      //sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      //sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundle"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  function getCurrentVariant() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    variantSelects.updateOptions();
    variantSelects.updateMasterId();
  
    return variantSelects.currentVariant;
  }

  // Product accordion
  const accordionList = document.querySelectorAll('.accordion-item');

  accordionList.forEach((event) =>
    event.addEventListener('click', () => {
      if (event.classList.contains('active')) {
        event.classList.remove('active');
      } else {
        accordionList.forEach((event2) => event2.classList.remove('active'));
        event.classList.add('active');
      }
    })
  );
  //product variants select
  const productVariantsSelect = document.querySelectorAll('.variant-select .select__select');

  productVariantsSelect.forEach((select) => {
    select.addEventListener('change', () => {
      document.querySelectorAll('.swiper-large .swiper-slide').forEach((slide, index) => {
          const fullId = slide?.dataset?.mediaId;
          if (fullId) {
            const mediaIdExact = fullId.split('-').pop();
            if (getCurrentVariant()?.featured_media) {
              if (mediaIdExact == getCurrentVariant().featured_media.id) {
                swiper.slideTo(index);
                swiper2.slideTo(index);
              }
            }
          }
        });
    });
  });

  // Product slider
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 24,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    threshold: 50,
  });
  var swiper2 = new Swiper('.swiper-large', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const slides = document.querySelectorAll('.swiper-large .swiper-slide');
  if (slides.length <= 1) {
    document.querySelector('.swiper-large .swiper-button-prev').style.display = 'none';
    document.querySelector('.swiper-large .swiper-button-next').style.display = 'none';
  }
  const sliderThumb = document.querySelector('.swiper-thumbs');
  window.addEventListener('resize', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      sliderThumb.style.display = 'none';
      // for (let i = 0; i < productVariantsSelect.length; i++) {
      //   productVariantsSelect[i].style.maxWidth = '100%';
      // }
    } else {
      sliderThumb.style.display = 'block';
      // if (productVariantsSelect.length == 1) {
      //   productVariantsSelect[0].style.maxWidth = '100%';
      //   productVariantsSelect[0].style.marginRight = '0';
      // } else if (productVariantsSelect.length >= 3) {
      //   for (let i = 0; i < productVariantsSelect.length; i++) {
      //     productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
      //     const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
      //     lastElement.style.maxWidth = '100%';
      //   }
      // }
    }
  });
  window.addEventListener('load', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      //sliderThumb.style.display = 'none';
      // for (let i = 0; i < productVariantsSelect.length; i++) {
      //   productVariantsSelect[i].style.maxWidth = '100%';
      // }
    } else {
      //sliderThumb.style.display = 'block';
      // if (productVariantsSelect.length == 1) {
      //   productVariantsSelect[0].style.maxWidth = '100%';
      //   productVariantsSelect[0].style.marginRight = '0';
      // } else if (productVariantsSelect.length >= 3) {
      //   for (let i = 0; i < productVariantsSelect.length; i++) {
      //     productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
      //     const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
      //     lastElement.style.maxWidth = '100%';
      //   }
      // }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-gift-card"]) return;
  try {
    
  // Product accordion
  const accordionList = document.querySelectorAll(".accordion-item");

  accordionList.forEach((event) =>
    event.addEventListener("click", () => {
      if (event.classList.contains("active")) {
        event.classList.remove("active");
      } else {
        accordionList.forEach((event2) => event2.classList.remove("active"));
        event.classList.add("active");
      }
    })
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-headboards"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  // Product accordion
  const accordionList = document.querySelectorAll('.accordion-item');

  accordionList.forEach((event) =>
    event.addEventListener('click', () => {
      if (event.classList.contains('accordion-product-option')) {
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
        }
        event.classList.add('active');
      } else {
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (!event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
          event.classList.add('active');
        }
      }
    })
  );
  //product variants select
  const productVariantsSelect = document.querySelectorAll('.variant-select .select__select');

  // Product slider
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 24,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    threshold: 50,
  });
  var swiper2 = new Swiper('.swiper-large', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const sliderThumb = document.querySelector('.swiper-thumbs');
  window.addEventListener('resize', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
  });
  window.addEventListener('load', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      //sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      //sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mattresses-nursery"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  function getCurrentVariant() {
    const variantMixed = document.querySelector('variant-mixed');
    if (!variantMixed) return;
    variantMixed.updateOptions();
    variantMixed.updateMasterId();
  
    return variantMixed.currentVariant;
  }

  // Product accordion
  const accordionList = document.querySelectorAll('.accordion-item');

  accordionList.forEach((event) =>
    event.addEventListener('click', () => {
      if (event.classList.contains('accordion-product-option')) {
        document.querySelectorAll('.swiper-large .swiper-slide').forEach((slide, index) => {
          const fullId = slide?.dataset?.mediaId;
          if (fullId) {
            const mediaIdExact = fullId.split('-').pop();
            if (getCurrentVariant()?.featured_media) {
              if (mediaIdExact == getCurrentVariant().featured_media.id) {
                swiper.slideTo(index);
                swiper2.slideTo(index);
              }
            }
          }
        });
        
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
        }
        event.classList.add('active');
      } else {
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (!event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
          event.classList.add('active');
        }
      }
    })
  );
  //product variants select
  const productVariantsSelect = document.querySelectorAll('.variant-select .select__select');

  // Product slider
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 24,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    threshold: 50,
  });
  var swiper2 = new Swiper('.swiper-large', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const sliderThumb = document.querySelector('.swiper-thumbs');
  window.addEventListener('resize', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
    if (document.querySelector('.additional_option__select')) {
      document.querySelector('.additional_option__select').style.maxWidth = '100%;';
    }
  });
  window.addEventListener('load', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      //sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      //sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          // productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
    if (document.querySelector('.additional_option__select')) {
      document.querySelector('.additional_option__select').style.maxWidth = '100%;';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mattresses"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  function getCurrentVariant() {
    const variantMixed = document.querySelector('variant-mixed');
    if (!variantMixed) return;
    variantMixed.updateOptions();
    variantMixed.updateMasterId();
  
    return variantMixed.currentVariant;
  }

  // Product accordion
  const accordionList = document.querySelectorAll('.accordion-item');

  accordionList.forEach((event) =>
    event.addEventListener('click', () => {
      if (event.classList.contains('accordion-product-option')) {
        document.querySelectorAll('.swiper-large .swiper-slide').forEach((slide, index) => {
          const fullId = slide?.dataset?.mediaId;
          if (fullId) {
            const mediaIdExact = fullId.split('-').pop();
            if (getCurrentVariant()?.featured_media) {
              if (mediaIdExact == getCurrentVariant().featured_media.id) {
                swiper.slideTo(index);
                swiper2.slideTo(index);
              }
            }
          }
        });
        
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
        }
        event.classList.add('active');
      } else {
        if (event.classList.contains('active')) {
          event.classList.remove('active');
        } else {
          accordionList.forEach((event2) => {
            if (!event2.classList.contains('accordion-product-option')) {
              event2.classList.remove('active');
            }
          });
          event.classList.add('active');
        }
      }
    })
  );
  //product variants select
  const productVariantsSelect = document.querySelectorAll('.variant-select .select__select');

  // Product slider
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 24,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    threshold: 50,
  });
  var swiper2 = new Swiper('.swiper-large', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const sliderThumb = document.querySelector('.swiper-thumbs');
  window.addEventListener('resize', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
    if (document.querySelector('.additional_option__select')) {
      document.querySelector('.additional_option__select').style.maxWidth = '100%;';
    }
  });
  window.addEventListener('load', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      //sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      //sliderThumb.style.display = 'block';
      if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          // productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
    if (document.querySelector('.additional_option__select')) {
      document.querySelector('.additional_option__select').style.maxWidth = '100%;';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  function getCurrentVariant() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    variantSelects.updateOptions();
    variantSelects.updateMasterId();
  
    return variantSelects.currentVariant;
  }

  // Product accordion
  const accordionList = document.querySelectorAll('.accordion-item');

  accordionList.forEach((event) =>
    event.addEventListener('click', () => {
      if (event.classList.contains('active')) {
        event.classList.remove('active');
      } else {
        accordionList.forEach((event2) => event2.classList.remove('active'));
        event.classList.add('active');
      }
    })
  );
  //product variants select
  const productVariantsSelect = document.querySelectorAll('.variant-select .select__select');

  productVariantsSelect.forEach((select) => {
    select.addEventListener('change', () => {
      document.querySelectorAll('.swiper-large .swiper-slide').forEach((slide, index) => {
          const fullId = slide?.dataset?.mediaId;
          if (fullId) {
            const mediaIdExact = fullId.split('-').pop();
            if (getCurrentVariant()?.featured_media) {
              if (mediaIdExact == getCurrentVariant().featured_media.id) {
                swiper.slideTo(index);
                swiper2.slideTo(index);
              }
            }
          }
        });
    });
  });

  // Product slider
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 24,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    threshold: 50,
  });
  var swiper2 = new Swiper('.swiper-large', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const slides = document.querySelectorAll('.swiper-large .swiper-slide');
  if (slides.length <= 1) {
    document.querySelector('.swiper-large .swiper-button-prev').style.display = 'none';
    document.querySelector('.swiper-large .swiper-button-next').style.display = 'none';
  }
  const sliderThumb = document.querySelector('.swiper-thumbs');
  window.addEventListener('resize', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      sliderThumb.style.display = 'block';
      if (productVariantsSelect.length == 1) {
        productVariantsSelect[0].style.maxWidth = '100%';
        productVariantsSelect[0].style.marginRight = '0';
      } else if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
  });
  window.addEventListener('load', () => {
    if (window.matchMedia('(max-width: 750px)').matches) {
      //sliderThumb.style.display = 'none';
      for (let i = 0; i < productVariantsSelect.length; i++) {
        productVariantsSelect[i].style.maxWidth = '100%';
      }
    } else {
      //sliderThumb.style.display = 'block';
      if (productVariantsSelect.length == 1) {
        productVariantsSelect[0].style.maxWidth = '100%';
        productVariantsSelect[0].style.marginRight = '0';
      } else if (productVariantsSelect.length >= 3) {
        for (let i = 0; i < productVariantsSelect.length; i++) {
          productVariantsSelect[i].style.maxWidth = 'calc(50% - 0.8rem)';
          const lastElement = productVariantsSelect[productVariantsSelect.length - 1];
          lastElement.style.maxWidth = '100%';
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  let otherRes = document.querySelector('.grid__item.pag-item + h4');
  if (otherRes == null) {
    otherRes = document.querySelector('.grid.product-grid.search-ajaxinate h4:first-child');
  }
  const prodRes = document.querySelector('.template-search__results > h4');

  const prods = document.querySelectorAll('.grid__item.prod-item');
  if (prods.length == 0 && otherRes !== null) {
    prodRes.style.display = 'none';
  } else if (otherRes !== null) {
    prodRes.style.display = 'block';
  }
  const notProds = document.querySelectorAll('.not-prod');
  if (notProds.length == 0 && otherRes !== null) {
    otherRes.style.display = 'none';
  } else if (otherRes !== null) {
    otherRes.style.display = 'block';
  }

  const openFiltersButton = document.querySelector('.open-filters');
  const facets = document.querySelector('.facets-container');
  let xFilter = document.querySelector('.facet-filters__field > h2 svg');
  const closeCurrentFacets = document.querySelectorAll('.close-filter-facet');
  const overlay = document.querySelector('.facets-overlay');
  //const backOptions = document.querySelectorAll('.template-search .facets-container .option-container .option-name-wrapper');

  const openFilters = () => {
    if (facets !== null) {
      facets.classList.add('show');
      overlay.classList.add('show');
      document.body.classList.add('overflow-hidden');
    }
  };

  const closeFilters = () => {
    if (facets !== null) {
      if (facets.classList.contains('show')) {
        document.body.classList.remove('overflow-hidden');
        facets.classList.remove('show');
      }
      overlay.classList.remove('show');
    }
  };

  const openCloseFilters = (e) => {
    if (e.target.closest('.open-filters')) {
      openFilters();
    } else if (!e.target.closest('.facets-container')) {
      closeFilters();
    }
  };

  if (xFilter !== null) {
    xFilter.addEventListener('click', closeFilters);
    xFilter.addEventListener('click', () => overlay.classList.remove('show'));
  }

  const showSorts = document.querySelectorAll('.option-container > .option-name');

  const handleClose = (currFacets) => {
    for (let i = 0; i < currFacets.length; i++) {
      currFacets[i].addEventListener('click', (e) => {
        e.target.closest('.facets__disclosure').querySelector('.facets__summary').click();
      });
    }
  };

  handleClose(closeCurrentFacets);

  const handleOneClose = (facet) => {
    facet.addEventListener('click', (e) => {
      e.target.closest('.facets__disclosure').querySelector('.facets__summary').click();
    });
  };

  const observer = new MutationObserver(function (mutations_list) {
    mutations_list.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (added_node) {
        const el = added_node;
        if (el instanceof Element) {
          if (el.classList.contains('facet-filters__field')) {
            console.log('found');
            const closeFacets = document.querySelectorAll('.facet-filters__field .close-filter-facet');
            xFilter = document.querySelector('.facet-filters__field > h2 svg');
            xFilter.addEventListener('click', closeFilters);
            xFilter.addEventListener('click', () => overlay.classList.remove('show'));
            handleClose(closeFacets);
          }
        }
      });
    });
  });

  if (document.querySelector('#FacetFiltersForm') !== null) {
    observer.observe(document.querySelector('#FacetFiltersForm'), { subtree: true, childList: true });
  }

  document.addEventListener('click', openCloseFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    

  const swipers = document.querySelectorAll('.multicolumn-swiper');
  const breakpoint = window.matchMedia( '(min-width:990px)' );  
  let multicolumnSwiper;
  
  const breakpointChecker = function(swiper) {  
    const multicolumnSwiperItem = swiper.querySelectorAll(".swiper-slide");
    const sectionId = swiper.getAttribute('data-attr');
    if ( breakpoint.matches === true && multicolumnSwiperItem.length <= 3 ) {    
      // clean up old instances and inline styles when available      
      if(swiper.swiper && typeof swiper.swiper.destroy === 'function'){ 
        swiper.swiper.destroy(true, true);
      }
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if ( breakpoint.matches === false ) {
      // fire small viewport version of swiper       
       return enableSwiper(multicolumnSwiperItem.length, sectionId);
    } else if (breakpoint.matches === true && multicolumnSwiperItem.length >= 4 ) {  
       return enableSwiper(multicolumnSwiperItem.length, sectionId);
    }
  };   

  const enableSwiper = function(multicolumnSwiperItemLength, sectionId) {
    if (multicolumnSwiperItemLength >= 4) {    
      multicolumnSwiper = new Swiper(`[data-attr=${sectionId}]`, {
        slidesPerView: 3,
        spaceBetween: 0,
        autoHeight: false,
        pagination: {
          el: `[data-attr=${sectionId}] .swiper-pagination`,
        },
        navigation: {
          nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
          prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 24,
          },			
          990: {
            slidesPerView: 3,
            spaceBetween: 24,
          }
        }
      });    
    } else if ((multicolumnSwiperItemLength <= 3 && multicolumnSwiperItemLength >= 2)  && window.innerWidth <= 990) {    
      multicolumnSwiper = new Swiper(`[data-attr=${sectionId}]`, {
        slidesPerView: 1,
        spaceBetween: 24,
        autoHeight: true,
        pagination: {
          el: `[data-attr=${sectionId}] .swiper-pagination`,
        },
        navigation: {
          nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
          prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
        },
      });
    }
  }
  for(let i = 0; i < swipers.length; i++) {
    let windowWidth = window.innerWidth;   
    window.addEventListener('resize', function() {
      if (window.innerWidth != windowWidth) {
        breakpointChecker(swipers[i]);
        windowWidth = window.innerWidth
      }
    });
    breakpointChecker(swipers[i]);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-selector"] && !Shopify.designMode) return;
  try {
    
window.Tawk_API.onLoad = function(){
    window.Tawk_API.hideWidget();
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-faqs"]) return;
  try {
    

  const imageFullBanner = document.querySelector('.banner.banner-full');

  imageFullBanner.querySelector('a').setAttribute('href',"javascript:void(Tawk_API.toggle())");

  const articleSwipers = document.querySelectorAll('.articles-swiper');

  const enableArticleSwiper = (sectionId) =>{
    var swiperInit = new Swiper(`[data-attr=${sectionId}]`, {
      slidesPerView: 1,
      spaceBetween: 12,
      autoHeight:true,
      navigation: {
        nextEl: `.swiper-arrows-${sectionId} .swiper-button-next`,
        prevEl: `.swiper-arrows-${sectionId} .swiper-button-prev`,
      },
      pagination: {
        el: `.swiper-arrows-${sectionId} .swiper-pagination`,
        clickable: true,
      },
      breakpoints:{
        750:{
          slidesPerView: 2,
          spaceBetween: 12
        },
        990:{
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    });
  }

  if(articleSwipers.length){
    for(let i = 0; i < articleSwipers.length; i++){
      const sectionId = articleSwipers[i].getAttribute('data-attr');
      enableArticleSwiper(sectionId);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const swipers = document.querySelectorAll('.related-products-swiper');
  const breakpoint = window.matchMedia('(min-width:990px)');
  let relatedProductsSwiper;

  const breakpointChecker = function (swiper) {
    const relatedProductsSwiperItem = swiper.querySelectorAll('.swiper-slide');
    const sectionId = swiper.getAttribute('data-attr');
    if (relatedProductsSwiperItem.length >= 3 && breakpoint.matches === true) {
      // swiper.closest('.related-products').style.paddingRight = '0'
      // swiper.style.overflow = 'visible';
    }

    if (breakpoint.matches === true && relatedProductsSwiperItem.length <= 1) {
      // clean up old instances and inline styles when available
      if (swiper.swiper && typeof swiper.swiper.destroy === 'function') {
        swiper.swiper.destroy(true, true);
      }
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if (breakpoint.matches === true && relatedProductsSwiperItem.length == 2) {
      swiper.closest('.related-products').querySelector('.swiper-controls').style.display = 'none';
      if (swiper.swiper && typeof swiper.swiper.destroy === 'function') {
        swiper.swiper.destroy(true, true);
      }
      return;
    } else if (breakpoint.matches === false && relatedProductsSwiperItem.length == 2) {
      // fire small viewport version of swiper
      swiper.closest('.related-products').querySelector('.swiper-controls').style.display = 'flex';
      return enableSwiper(relatedProductsSwiperItem.length, sectionId);
    } else if (breakpoint.matches === true && relatedProductsSwiperItem.length >= 2) {
      return enableSwiper(relatedProductsSwiperItem.length, sectionId);
    } else if (breakpoint.matches === false && relatedProductsSwiperItem.length >= 2) {
      return enableSwiper(relatedProductsSwiperItem.length, sectionId);
    }
  };

  const enableSwiper = function (relatedProductsSwiperItemLength, sectionId) {
    if (relatedProductsSwiperItemLength >= 3) {
      relatedProductsSwiper = new Swiper(`[data-attr=${sectionId}]`, {
        slidesPerView: 3,
        spaceBetween: 24,
        pagination: {
          el: `[data-attr=${sectionId}] .swiper-pagination`,
        },
        navigation: {
          nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
          prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    } else if (relatedProductsSwiperItemLength == 2 && window.innerWidth <= 990) {
      relatedProductsSwiper = new Swiper(`[data-attr=${sectionId}]`, {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
          el: `[data-attr=${sectionId}] .swiper-pagination`,
        },
        navigation: {
          nextEl: `[data-attr=${sectionId}] .swiper-button-next`,
          prevEl: `[data-attr=${sectionId}] .swiper-button-prev`,
        },
      });
    }
  };
  for (let i = 0; i < swipers.length; i++) {
    if (swipers[i].querySelectorAll('.swiper-slide').length === 0) {
      swipers[i].closest('.related-products').style.display = 'none';
    }
    window.addEventListener('resize', function () {
      breakpointChecker(swipers[i]);
    });
    breakpointChecker(swipers[i]);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-image"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded',function(){
    const videoContainer = document.querySelectorAll('.c-video');
    const isMobile = function() {
      try {
          document.createEvent('TouchEvent');
          return true;
      } catch (e) {
          return false;
      }
    };
    for(let i = 0; i < videoContainer.length; i++){
      if(isMobile()){
        videoContainer[i].classList.add('mobile-video','show-controls');
        videoContainer[i].addEventListener('click',function(e){
          if(e.target.closest('.buttons') && e.target.closest('.c-video').classList.contains('show-controls')){
            videoContainer[i].classList.remove('overlay');
          }
          if(!e.target.closest('.c-video')){
            videoContainer[i].classList.remove('show-controls');
          }
          else{
            videoContainer[i].classList.add('show-controls');
          }
        });
      } 
      else{
        videoContainer[i].addEventListener('click',function(e){
          if(e.target.closest('.buttons') && e.target.closest('.c-video').classList.contains('show-controls')){
            videoContainer[i].classList.remove('show-controls','overlay');
          }
        });
      }
      const togglePlayPause = (e) => { 
        if(video.paused){
          video.play();
          e.target.closest('.buttons').querySelector('.pp').className = 'pp pause';
        }
        else{
          video.pause();
          e.target.closest('.buttons').querySelector('.pp').className = 'pp play';
        }
      }
      
      const toggleSound = (e) => {
        if(video.muted){
          video.muted = false;
          e.target.className = 'sound mute';
        }
        else{
          video.muted = true;
          e.target.className = 'sound unmute';
        }
      }
      
      const updateProgress = () => {
        const pos = (video.currentTime / video.duration) * 100;
        progress.style.width = pos + '%';
        if(video.ended){
          btn.querySelector('.pp').className = 'pp play';
        }
      }
      
      const toggleFull = (e) => {
        if(!e.target.classList.contains('fullscreen')){
          e.target.classList.add('fullscreen');
          if(videoContainer[i].closest('.c-video').requestFullscreen){
            videoContainer[i].closest('.c-video').requestFullscreen();
          }
          else if(videoContainer[i].closest('.c-video').mozRequestFullScreen){
            videoContainer[i].closest('.c-video').mozRequestFullScreen();
          }
          else if(videoContainer[i].closest('.c-video').webkitRequestFullscreen){
            videoContainer[i].closest('.c-video').webkitRequestFullscreen();
          }
          else if(videoContainer[i].closest('.c-video').msRequestFullscreen){
            videoContainer[i].closest('.c-video').msRequestFullscreen();
          }
          else if(videoContainer[i].querySelector('.video').webkitEnterFullscreen){
            videoContainer[i].querySelector('.video').webkitEnterFullscreen();
            e.target.classList.remove('fullscreen');
          }
        }
        else{
          e.target.classList.remove('fullscreen');
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else if(videoContainer[i].querySelector('.video').webkitExitFullscreen){
            videoContainer[i].querySelector('.video').webkitExitFullscreen();
          }
        }
      }
      
      const clickProgress = (e) => {
        const pos = (e.offsetX / progressBar.offsetWidth) * video.duration;
        video.currentTime = pos;
      }
    
      const progressBar = videoContainer[i].querySelector('.progress-bar');
      const btn = videoContainer[i].querySelector('#play-pause');
      const volume = videoContainer[i].querySelector('.sound');
      const full = videoContainer[i].querySelector('.full');
      const progress = videoContainer[i].querySelector('.progress');
      const video = videoContainer[i].querySelector('.video');
      btn.addEventListener('click', togglePlayPause);
      video.addEventListener('timeupdate', updateProgress);
      volume.addEventListener('click', toggleSound);
      full.addEventListener('click', toggleFull);
      progressBar.addEventListener('click', clickProgress);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  const testimonialSwipers = document.querySelectorAll('.testimonial-swiper');

  const enableTestimonialSwiper = (sectionId) =>{
    var swiperInit = new Swiper(`[data-attr=${sectionId}]`, {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight:true,
      pagination: {
        el: `.swiper-arrows-${sectionId} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `.swiper-arrows-${sectionId} .swiper-button-next`,
        prevEl: `.swiper-arrows-${sectionId} .swiper-button-prev`,
      }
    });
  }

  if(testimonialSwipers.length){
    for(let i = 0; i < testimonialSwipers.length; i++){
      const sectionId = testimonialSwipers[i].getAttribute('data-attr');
      enableTestimonialSwiper(sectionId);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usps"] && !Shopify.designMode) return;
  try {
    
  const swipers = document.querySelectorAll('.usp-swiper');
  const breakpoint = window.matchMedia( '(min-width:990px)' )
  let uspSwiper;
  let uspPadding = 24;
  if(document.querySelector('.usps').classList.contains('less-spacing')){
    uspPadding = 24;
  }
  if(document.querySelector('.usps').classList.contains('more-spacing')){
    uspPadding = 81;
  }
  
  const breakpointChecker = function(swiper) {  
    const uspSwiperItem = swiper.querySelectorAll(".swiper-slide");
    const sectionId = swiper.getAttribute('data-attr');   
    if ( breakpoint.matches === true && uspSwiperItem.length <= 4 ) {    
      // clean up old instances and inline styles when available      
      if(swiper.swiper && typeof swiper.swiper.destroy === 'function'){ 
        swiper.swiper.destroy(true, true);
      }
      // or/and do nothing
      return;
      // else if a small viewport and single column layout needed
    } else if ( breakpoint.matches === false ) {
      // fire small viewport version of swiper            
       return enableSwiper(uspSwiperItem.length, sectionId);
    } else if (breakpoint.matches === true && uspSwiperItem.length >= 5 ) {  
       return enableSwiper(uspSwiperItem.length, sectionId);
    }
  };   

  const enableSwiper = function(uspSwiperItemLength, sectionId) {
    let mediaSwiper = document.querySelector(`[data-attr="${sectionId}"] .media`);
    let slideSpacing = 0;
    if(mediaSwiper){
      slideSpacing = 24;
    }
    if (uspSwiperItemLength >= 5) {        
      uspSwiper = new Swiper(`[data-attr="${sectionId}"]`, {
        slidesPerView: 1,
        spaceBetween: 24,
        autoHeight:true,
        pagination: {
          el: `.swiper-pagination`,
          clickable: true,
        },
        navigation: {
          nextEl: `.swiper-button-next`,
          prevEl: `.swiper-button-prev`,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 24,
          },			
          990: {
            slidesPerView: 4,
            spaceBetween: uspPadding,
          }
        }
      });      
    } else if ((uspSwiperItemLength <= 4 && uspSwiperItemLength >= 2)  && window.innerWidth <= 990) {          
      uspSwiper = new Swiper(`[data-attr="${sectionId}"]`, {
        slidesPerView: 1,
        spaceBetween: 24,
        pagination: {
          el: `.swiper-pagination`,
          clickable: true,
        },
        navigation: {
          nextEl: `.swiper-button-next`,
          prevEl: `.swiper-button-prev`,
        },
      });           
    }
  }
  for(let i = 0; i < swipers.length; i++) {   
    window.addEventListener('resize', function() {
      breakpointChecker(swipers[i]);
    });
    breakpointChecker(swipers[i]);
  }

  } catch(e) { console.error(e); }
})();
})();
